export default __webpack_public_path__ + "static/media/AVRT.e98c8f44.png";